module.exports = __webpack_public_path__ + "static/img/wlaqzcfw.c735657.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wlaqzcfw.jpg
// module id = 6VDw
// module chunks = 0